export default __webpack_public_path__ + "static/media/logo-saving.1ba9a21d.png";